import { Inbox, type LucideIcon } from 'lucide-react';
import { ActionButton, type FeedbackAction } from './action';

type EmptyStateProps = { message: string; icon?: LucideIcon; action?: FeedbackAction };

// Illustration-free: an icon, one sentence that says what to do next, one action (design system §4, §5).
export function EmptyState({ message, icon: Icon = Inbox, action }: EmptyStateProps) {
  return (
    <div className="flex flex-col items-center gap-4 p-8 text-center">
      <Icon aria-hidden className="size-(--icon-lg) text-muted" />
      <p className="text-sm text-muted">{message}</p>
      {action && <ActionButton action={action} />}
    </div>
  );
}
